module.exports = __webpack_public_path__ + "static/media/TJ-whyjoe-hero.23eeae4f.jpg";